import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import EnrichmentPanel from '../../../../components/Editor/EditPanel/EnrichmentPanel';

interface EnrichmentPanelOwnProps {
	page: number;
}

const mapStateToProps = (state: StoreState, { page }: EnrichmentPanelOwnProps) => {
	const {
		editor: {
			activeItem: { id },
			editableEnrichments,
		},
		importManager: { byId },
	} = state;

	const {
		resource,
		defaultResource,
		importManagerId,
	} = editableEnrichments[page][id];

	return {
		page,
		id,
		resource,
		defaultResource,
		importManagerId,
		isImporting: !!byId[importManagerId],
	};
};

export default connect(mapStateToProps)(EnrichmentPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/EnrichmentPanel/index.tsx